import { useCallback, useEffect, useState } from "react";
import { fetchOccurrencesByMainOccurrenceId } from "../api/tas";
import { IOccurrence } from "../components/support/types";

export const useSupportByOccurrence = (occurrenceId?: string | number) => {
  const [openOccurrences, setOpenOccurrences] = useState<IOccurrence[]>([]);
  const [finishedOccurrences, setFinishedOccurrences] = useState<IOccurrence[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [subject, setSubject] = useState("");
  const [responsible, setResponsible] = useState("");

  const load = useCallback(async () => {
    if (!occurrenceId) return;

    setLoading(true);
    try {
      const { open, finished } = await fetchOccurrencesByMainOccurrenceId(String(occurrenceId), {
        searchTerm: searchTerm || undefined,
        subject: subject || undefined,
        responsible: responsible || undefined,
      });
      setOpenOccurrences(open);
      setFinishedOccurrences(finished);
    } finally {
      setLoading(false);
    }
  }, [occurrenceId, searchTerm, subject, responsible]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    openOccurrences,
    finishedOccurrences,
    loading,
    searchTerm,
    setSearchTerm,
    subject,
    setSubject,
    responsible,
    setResponsible,
    refetch: load,
  };
};
